/**
 * @file: The id of the calendar event of an interval.
 *
 * The scene collection service builds the events of the calendar and gives
 * each event this id. The calendar finds the event of an interval with the
 * same id. The rule is in client/common, because a service in common must not
 * import from a component.
 */

/**
 * Give the id of the calendar event of an interval.
 *
 * @param {number|string} intervalId
 * @returns {string}
 */
export const calendarEventId = intervalId => `interval_${intervalId}`
